import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostInspectionDiyDocumentationTab from "./component";
import { withRouter } from "react-router-dom";
import { diyPaymentApprovalProcess, fetchLoanDetails, getDsiEligibility, getPurchaseRequestDetails, setActiveTab, setPageLoading } from "../post-inspection-diy/actions";

const mapStateToProps = ({
    postInspectionDiy: {
        activeTab,
        postTokenDocuments,
        inspectionResponse,
        auctionResponse,
        pickupDetail,
        helperVideos,
        continueLoading,
        showSelfBought,
        franchiseDetails
    }
}) => ({
    activeTab,
    postTokenDocuments,
    inspectionResponse,
    auctionResponse,
    pickupDetail,
    helperVideos,
    continueLoading,
    showSelfBought,
    franchiseDetails
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setActiveTabConnect: setActiveTab,
    diyPaymentApprovalProcessConnect: diyPaymentApprovalProcess,
    getPurchaseRequestDetailsConnect: getPurchaseRequestDetails,
    getDsiEligibilityConnect: getDsiEligibility,
    setPageLoadingConnect: setPageLoading,
    fetchLoanDetailsConnect: fetchLoanDetails
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PostInspectionDiyDocumentationTab));
